"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrintableBarcodeFormat = void 0;
exports.PrintableBarcodeFormat = {
    DSKU: "DSKU",
    FNSKU: "FNSKU",
    GTIN14: "GTIN14",
    UPC: "UPC",
};
//# sourceMappingURL=printable-barcode-format.js.map